import CalculateMonthlyPay from "./CalculateMonthlyPay";

interface payRecords {
    is_Duplicate: number;
    Pay_frequency: any;
    Net_Pay: number | string | null;
}
const CalculateMonthlyNetPay = (payRecords:payRecords[]) => {
    const mappedNetPayRecords= payRecords.map(file=>({...file,Pay:file.Net_Pay}))
    return CalculateMonthlyPay(mappedNetPayRecords);
}

export default CalculateMonthlyNetPay;